import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import axios from "axios";

// Suppress ResizeObserver errors
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (
    typeof args[0] === 'string' && 
    args[0].includes('ResizeObserver loop')
  ) {
    return;
  }
  resizeObserverErr(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// 2026-11-01: when the backend says the session expired, clear it and go to login
// instead of leaving the dashboard with empty / endlessly loading panels.
const _sessionExpired = () => {
  try {
    ['token', 'user'].forEach((k) => { localStorage.removeItem(k); sessionStorage.removeItem(k); });
  } catch (e) { /* storage unavailable */ }
  if (!window.location.pathname.startsWith('/login')) {
    window.location.href = '/login?expired=1';
  }
};
const _origFetch = window.fetch.bind(window);
window.fetch = async (...args) => {
  const res = await _origFetch(...args);
  if (res.status === 401 && res.headers.get('X-Session-Expired') === '1') _sessionExpired();
  return res;
};
axios.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && err.response.headers?.['x-session-expired'] === '1') _sessionExpired();
    return Promise.reject(err);
  },
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
